<template>
  <VIcon :small="$vuetify.breakpoint.xsOnly">
    {{ closeIcon }}
  </VIcon>
</template>

<script>
export default {
  name: 'Close',
  data() {
    return {
      closeIcon: 'M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z',
    };
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 374px) {
  .btn-close.v-btn {
    right: 0.875rem;
    svg {
      width: 1rem;
    }
  }
}
</style>
